import { render } from "./election-phase-selector.vue?vue&type=template&id=77af02a0"
import script from "./election-phase-selector.vue?vue&type=script&lang=js"
export * from "./election-phase-selector.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__